import React, { useState } from "react";
import MeniulLateralRapoarte from "../componente/Rapoarte/MeniulLateralRapoarte";
import RaportPrivireGenerala from "../componente/Rapoarte/RaportPrivireGenerala";
import RaportFinanciar from "../componente/Rapoarte/RaportFinanciar";
import RaportSocial from "../componente/Rapoarte/RaportSocial";
import RapoarteHeatmap from "../componente/Rapoarte/RapoarteHeatmap";


import "./stiluri/PaginaRapoarte.css";

const PaginaRapoarte = () => {
  const [sectiuneSelectata, setSectiuneSelectata] = useState("privireGenerala");

  const renderSectiune = () => {
    switch (sectiuneSelectata) {
      case "privireGenerala":
        return <RaportPrivireGenerala />;
      case "financiar":
        return <RaportFinanciar />;
      case "social":
        return <RaportSocial />;
         case "heatmap":
        return <RapoarteHeatmap />;
      default:
        return <h2>Selectează un raport din meniu</h2>;
    }
  };

  return (
    <div className="container-rapoarte">
      <MeniulLateralRapoarte onSectiuneSelectata={setSectiuneSelectata} />
      <div className="zona-continut">
        {renderSectiune()}
      </div>
    </div>
  );
};

export default PaginaRapoarte;
